import { useEffect, useState } from "react";
import { mediaSrc } from "../lib/media";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function BannerCarousel({ banners = [] }) {
  const [idx, setIdx] = useState(0);
  const n = banners.length;

  useEffect(() => {
    if (n <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % n), 6000);
    return () => clearInterval(t);
  }, [n]);

  if (n === 0) return null;
  const go = (d) => setIdx((i) => (i + d + n) % n);

  return (
    <div className="relative w-full overflow-hidden rounded-2xl bg-clinical" data-testid="banner-carousel">
      <div className="relative h-56 sm:h-72 lg:h-80">
        {banners.map((b, i) => (
          <div
            key={b.id || i}
            className={`absolute inset-0 transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            style={{
              backgroundImage: `linear-gradient(90deg, rgba(21,56,89,0.92) 0%, rgba(21,56,89,0.55) 60%, rgba(21,56,89,0.3) 100%), url(${mediaSrc(b.image_url)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="h-full max-w-2xl flex flex-col justify-center px-6 sm:px-12">
              {b.title && <h2 key={`t-${idx}-${i}`} className={`font-heading font-black text-2xl sm:text-4xl tracking-tight text-white text-balance ${i === idx ? "banner-caption-in" : ""}`} style={i === idx ? { animationDelay: "0.15s" } : undefined}>{b.title}</h2>}
              {b.description && <p key={`d-${idx}-${i}`} className={`text-white/85 mt-3 text-sm sm:text-base leading-relaxed max-w-xl ${i === idx ? "banner-caption-in" : ""}`} style={i === idx ? { animationDelay: "0.32s" } : undefined}>{b.description}</p>}
            </div>
          </div>
        ))}
      </div>

      {n > 1 && (
        <>
          <button onClick={() => go(-1)} data-testid="banner-prev" className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/35 text-white rounded-full p-2 backdrop-blur">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button onClick={() => go(1)} data-testid="banner-next" className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/35 text-white rounded-full p-2 backdrop-blur">
            <ChevronRight className="w-5 h-5" />
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {banners.map((b, i) => (
              <button key={b.id || i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-2 bg-white/50"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
